import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Tile from '../SearchGroup/SearchTile';
import Flex from '../Flex';

export default class MultiSelect extends Component {
  static propTypes = {
    options: PropTypes.array,
    value: PropTypes.string,
    onChange: PropTypes.func,
    wrap: PropTypes.bool,
    isResetSearch: PropTypes.bool,
    isDisplayTile: PropTypes.bool,
  };

  static defaultProps = {
    options: [],
    value: '',
    onChange: _.noop,
    wrap: false,
  };

  constructor(...args) {
    super(...args)
    this.state = {
      selected: []
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isResetSearch !== this.props.isResetSearch && this.props.isResetSearch){
      this.setState({selected: []})
      }
  }

  onChange(value) {
    if (_.includes(this.state.selected, value)) {
      // remove value
      let newSelected = _.reject(this.state.selected, (v) => v === value)
      this.setState({
        selected: newSelected
      })
      this.props.onChange(newSelected)
    } else {
      // add value
      let newSelected = _.concat(this.state.selected, value)
      this.setState({
        selected: newSelected
      })
      this.props.onChange(newSelected)
    }

  }

  render() {
    let { selected } = this.state
    return (
      <Flex className='multiselect__wrapper' align='f' h wrap={this.props.wrap ? 'wrap' : 'none'}>
        {_.map(this.props.options, (o, i) => (
          <Tile
            isDisplayTile={this.props.isDisplayTile}
            key={i}
            grow={!this.props.wrap}
            option={o}
            onClick={(val) => this.onChange(val)}
            selected={_.includes(selected, o.value)}
          >
            <Flex dir='ttb' just='b' align='c'>
              {o.icon ?
                <img alt='' width={30} height={30} style={{ margin: 5 }} src={_.includes(selected, o.value) ? o.iconSelected : o.icon} />
                : null
              }
              <div>{_.get(o, 'label')}</div>
            </Flex>
          </Tile>
        )
        )}
      </Flex>
    )
  }
}
